'use client';

import { useState } from 'react';
import { SearchFilterContentTypes } from 'stockblocks-client';

import NavSearch from '../elements/NavSearch';
import { SearchBarVariant } from '../elements/NavSearchElements/searchUtils';
import { getSearchUrl } from '../utils/SearchUtils';

export default function SearchBar({ imagesUrl, searchOrigin, useSnapshotsUI }) {
    const [showSuggestions, setShowSuggestions] = useState(false);
    const handleSubmit = (contentType, searchTerm, searchOriginOverride) => {
        const searchUrl = getSearchUrl({
            contentType: contentType,
            searchTerm: searchTerm,
            searchOrigin: searchOriginOverride || searchOrigin,
        });
        window.location.href = searchUrl;
    };

    return (
        <NavSearch
            contentType={SearchFilterContentTypes.All_videos_content_type}
            onSubmit={handleSubmit}
            userHasAnySubscription
            isEnterpriseMember
            pproPluginEnabled
            isSearchAppLoaded={() => false}
            imagesUrl={imagesUrl}
            searchOrigin={searchOrigin}
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            useSnapshots={useSnapshotsUI || false}
            searchBarVariant={SearchBarVariant.TopNav}
        />
    );
}
